import { AABBModel } from './AABBModel';

export class BorderModel extends AABBModel {
    public key: string = '';
    public roomIndex: number = 0;
    public visible: boolean = true;

    public constructor() {
        super();
    }
}
